﻿import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

const TemplateContext = createContext(null);

export const useTemplateContext = () => {
    const ctx = useContext(TemplateContext);
    if (!ctx) throw new Error('useTemplateContext must be used within a TemplateProvider');
    return ctx;
};

export const TemplateProvider = ({ children }) => {
    const { id } = useParams();
    const [addedMedia, setAddedMedia] = useState([]);
    const [removedMedia, setRemovedMedia] = useState([]);

    const registerMediaAdded = useCallback((addedMediaRefs) => {
        setAddedMedia((prev) => {
            const added = addedMediaRefs.filter(ref => !prev.includes(ref));
            return Array.from(new Set([...prev, ...added]));
        });
    }, []);

    const registerMediaDeleted = useCallback((mediaReferences) => {
        setRemovedMedia((prev) =>
            prev.includes(mediaReferences) ? prev : [...prev, ...mediaReferences]
        );

        setAddedMedia((prev) =>
            prev.filter((ref) => !mediaReferences.includes(ref))
        );
    }, []);

    const contextValue = useMemo(() => ({
        templateId: id,
        addedMedia,
        removedMedia,
        registerMediaAdded,
        registerMediaDeleted
    }), [id, addedMedia, removedMedia, registerMediaAdded, registerMediaDeleted]);

    return (
        <TemplateContext.Provider
            value={contextValue}
        >
            {children}
        </TemplateContext.Provider>
    );
};
